module.exports = __webpack_public_path__ + "img/Expert.01454955.svg";